import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";
import {
  CostResponse,
  ExportCostPayload,
  ExportCostResponse,
  LocalCostResponse,
  ImportCostPayload,
  ImportCostResponse,
  LocalCostPayload,
  LocalCostProps,
  PricingResponse,
} from "type/pricing";

export const getPricing = createApi({
  reducerPath: "getPricing",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getPricing: builder.query<PricingResponse, void>({
      query: () => ({
        url: `client/cost?t=local`,
        method: "GET",
      }),
    }),
    getOrderPrice: builder.mutation<CostResponse, LocalCostPayload>({
      query: (body) => ({
        url: `order/cost`,
        method: "POST",
        body,
      }),
    }),
    getLocalCostPrice: builder.mutation<LocalCostResponse, LocalCostProps>({
      query: (body) => ({
        url: `order/costWithDiscount`,
        method: "POST",
        body,
      }),
    }),
    getImportCostPrice: builder.mutation<ImportCostResponse, ImportCostPayload>(
      {
        query: (body) => ({
          url: `orders/import-price`,
          method: "POST",
          body,
        }),
      }
    ),
    getExportCostPrice: builder.mutation<ExportCostResponse, ExportCostPayload>(
      {
        query: (body) => ({
          url: `orders/export-price`,
          method: "POST",
          body,
        }),
      }
    ),
  }),
});

export const {
  useGetPricingQuery,
  useGetLocalCostPriceMutation,
  useGetOrderPriceMutation,
  useGetImportCostPriceMutation,
  useGetExportCostPriceMutation,
} = getPricing;
